import PropTypes from "prop-types"
import React from "react"

import BaseAvatar from "src/components/BaseAvatar"
import SelectionChip from "src/components/SelectionChip"

const ContactSummaryChip = ({ contact, onRemove }) => {
  if (!contact?.name) return null
  const phone = contact.displayPhone || contact.phone
  const photoUrl =
    contact.thumbnailUrl || contact.thumbnail_url || contact.photoUrl
  const avatarBackground =
    contact.avatarBackgroundColor ||
    contact.avatar_background_color ||
    "bg-blue-100"

  const avatar = (
    <BaseAvatar
      size="xxs"
      src={photoUrl}
      name={contact.name}
      backgroundColor={photoUrl ? undefined : avatarBackground}
    />
  )

  return (
    <SelectionChip
      avatar={avatar}
      onRemove={onRemove}
      ariaLabel="Selected customer"
    >
      <span className="truncate font-medium text-gray-900">{contact.name}</span>
      {contact.email && (
        <>
          <span className="text-gray-300" aria-hidden="true">
            ·
          </span>
          <span className="truncate text-gray-500">{contact.email}</span>
        </>
      )}
      {phone && (
        <>
          <span className="text-gray-300" aria-hidden="true">
            ·
          </span>
          <span className="whitespace-nowrap text-gray-500">{phone}</span>
        </>
      )}
    </SelectionChip>
  )
}

ContactSummaryChip.propTypes = {
  contact: PropTypes.shape({
    name: PropTypes.string.isRequired,
    email: PropTypes.string,
    phone: PropTypes.string,
    displayPhone: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    thumbnail_url: PropTypes.string,
    photoUrl: PropTypes.string,
    avatarBackgroundColor: PropTypes.string,
    avatar_background_color: PropTypes.string,
  }),
  onRemove: PropTypes.func,
}

export default ContactSummaryChip
